export function grayOutField(key) {
  return (item) => {
    return item.quantity > 0 ? item[key] : <span style={{color: 'lightgray'}}>{item[key]}</span>
  }
}
